import { render } from "./SuperSavingMoneyBuyRecord.vue?vue&type=template&id=4e230459&scoped=true"
import script from "./SuperSavingMoneyBuyRecord.vue?vue&type=script&lang=js"
export * from "./SuperSavingMoneyBuyRecord.vue?vue&type=script&lang=js"

import "./SuperSavingMoneyBuyRecord.vue?vue&type=style&index=0&id=4e230459&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e230459"]])

export default __exports__